/**
 * useArchiveStats — the ONLY way the frontend obtains archive statistics.
 * Single backend source of truth (/api/stats), refreshed every 60s.
 * No component may hard-code an archive number.
 */
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let _shared = null; // module-level cache shared across components

export const useArchiveStats = () => {
  const [stats, setStats] = useState(_shared);

  useEffect(() => {
    let dead = false;
    const load = () =>
      axios.get(`${API}/stats`, { timeout: 15000 })
        .then((r) => { _shared = r.data; if (!dead) setStats(r.data); })
        .catch(() => { /* keep previous values; never flash wrong numbers */ });
    load();
    const t = setInterval(load, 60000);
    return () => { dead = true; clearInterval(t); };
  }, []);

  return stats; // null while loading
};
